import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript, Marker, Polyline } from "@react-google-maps/api";
import LocationSearch from "./LocationSearch";

const GOOGLE_MAPS_API_KEY = "AIzaSyASU8wb6swDIo3dNxkyjfraWijCImc3-OU";
const GOOGLE_MAP_LIBRARIES = ["places"];
const DEFAULT_CENTER = { lat: 37.7749, lng: -122.4194 };

const mapOptions = {
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  clickableIcons: false,
};

export default function DataCollectionMap({ paths, selectedPathId, draftPoints, isDrawing, onAddPoint }) {
  const [map, setMap] = useState(null);
  const visiblePaths = selectedPathId ? paths.filter((path) => path.id === selectedPathId) : paths;
  const arrowIcon = map && window.google?.maps ? [{
    icon: { path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW, scale: 3 },
    offset: "50%",
    repeat: "90px",
  }] : [];

  const handleMapClick = (event) => {
    if (!isDrawing) return;
    onAddPoint({ lat: event.latLng.lat(), lng: event.latLng.lng() });
  };

  useEffect(() => {
    if (!map || !window.google?.maps?.LatLngBounds || isDrawing) return;
    const pathsToFit = selectedPathId ? paths.filter((path) => path.id === selectedPathId) : paths;
    const points = pathsToFit.flatMap((path) => path.points || []);
    if (!points.length) return;

    const bounds = new window.google.maps.LatLngBounds();
    points.forEach((point) => bounds.extend(point));
    if (points.length === 1) {
      map.panTo(points[0]);
      map.setZoom(16);
    } else {
      map.fitBounds(bounds, 70);
    }
  }, [map, paths, selectedPathId, isDrawing]);

  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={GOOGLE_MAP_LIBRARIES}>
      <div className={`dc-map-wrap ${isDrawing ? "is-drawing" : ""}`}>
        <LocationSearch map={map} />
        {isDrawing && <div className="dc-map-hint">Click the map to add points · maximum 25</div>}
        <GoogleMap
          mapContainerClassName="dc-map"
          center={DEFAULT_CENTER}
          zoom={11}
          options={mapOptions}
          onLoad={setMap}
          onUnmount={() => setMap(null)}
          onClick={handleMapClick}
        >
          {visiblePaths.map((path) => (
            <Polyline
              key={path.id}
              path={path.points || []}
              options={{
                strokeColor: path.id === selectedPathId ? "#f97316" : "#2563eb",
                strokeOpacity: 0.9,
                strokeWeight: path.id === selectedPathId ? 7 : 5,
                icons: arrowIcon,
              }}
            />
          ))}
          {draftPoints.length > 1 && (
            <Polyline path={draftPoints} options={{ strokeColor: "#f97316", strokeWeight: 5, icons: arrowIcon }} />
          )}
          {draftPoints.map((point, index) => (
            <Marker key={`${point.lat}-${point.lng}-${index}`} position={point} label={`${index + 1}`} />
          ))}
        </GoogleMap>
      </div>
    </LoadScript>
  );
}
